import React from 'react'
import cx from 'classnames'
import Navigation from '/js/views/shared/components/navigation'
import Header from '/js/views/shared/components/header'
import Hero from '/js/views/shared/components/hero'
import Intro from '/js/views/shared/components/intro'
import HighlightSection from '/js/views/shared/components/highlightSection'
import StorySection from '/js/views/shared/components/storySection'
import Image from '../components/contentParticles/image'
import { Citations } from '../components/citations'

class ContentPageLayout extends React.Component {
  render() {
    const { shared, currentPage, routes, pageData, theme } = this.props

    return (
      <>
        <Navigation
          navigation={shared.navigation}
          social={shared.social}
          currentPage={currentPage}
          routes={routes}
          theme={theme}
        />
        <Header
          header={shared.header}
          theme={theme}
          currentPage={currentPage}
          routes={routes}
        />

        <div data-label="content-page-layout">
          <Hero hero={pageData.hero} graphic={pageData.graphic} theme={theme} />
          <Intro intro={pageData.intro} theme={theme} />
          {pageData.images && (
            <div className="container mb-30">
              {pageData.images.map((image) => (
                <Image key={image.key} images={image} />
              ))}
            </div>
          )}
          {pageData.caption && (
            <div className="container">
              <p
                className="text-12 text-granite-gray pt-5"
                dangerouslySetInnerHTML={{ __html: pageData.caption }}
              />
            </div>
          )}
          <HighlightSection highlights={pageData.highlights} theme={theme} />

          {pageData.citations && (
            <div className="container pb-48">
              <Citations citations={pageData.citations} />
            </div>
          )}

          {pageData.sdg && (
            <div className="container pb-48 flex">
              {pageData.sdg.map((icon, index) => {
                return (
                  <div
                    key={index}
                    className={cx({
                      'ml-10': index === 0 && pageData.sdg.length === 1,
                      'mr-10': index === 0 && pageData.sdg.length > 1,
                    })}
                  >
                    <a className="block" href="/appendix#un">
                      <Image key={index} images={icon} sdg />
                    </a>
                  </div>
                )
              })}
            </div>
          )}
        </div>
        <StorySection
          story={pageData.story}
          theme={theme}
          icon={pageData.graphic.icon}
          title={pageData.hero.title}
          currentPage={currentPage}
          routes={routes}
        />
      </>
    )
  }
}

export default ContentPageLayout
